/* global __APP_BUILD_ID__ */
import Vue from "vue";
import ModalAppUpdate from "../components/ModalAppUpdate.vue";
import i18n from "../plugins/i18n_single_language_file";

const APP_BUILD_ID =
  typeof __APP_BUILD_ID__ !== "undefined" ? __APP_BUILD_ID__ : "dev";
const APP_BUILD_STORAGE_KEY = "admin-vue-build-id";
const APP_UPDATE_MODAL_ROOT_ID = "app-update-modal-root";
const IS_PRODUCTION = process.env.NODE_ENV === "production";
const IS_DEV_UPDATE_CHECK_ENABLED =
  process.env.VUE_APP_ENABLE_UPDATE_CHECK === "true";

function showUpdateModal(onRefresh) {
  if (document.getElementById(APP_UPDATE_MODAL_ROOT_ID)) {
    return;
  }

  const rootNode = document.createElement("div");
  rootNode.id = APP_UPDATE_MODAL_ROOT_ID;
  document.body.appendChild(rootNode);

  const ModalClass = Vue.extend(ModalAppUpdate);
  const instance = new ModalClass({
    i18n,
  });

  instance.$on("refresh", () => {
    onRefresh();
  });

  instance.$mount(rootNode);
}

export function notifyAndReloadIfUpdated() {
  if (!IS_PRODUCTION && !IS_DEV_UPDATE_CHECK_ENABLED) {
    return false;
  }

  try {
    const previousBuildId = window.localStorage.getItem(APP_BUILD_STORAGE_KEY);
    const hasPreviousBuild = Boolean(previousBuildId);
    const isUpdatedBuild = previousBuildId !== APP_BUILD_ID;

    window.localStorage.setItem(APP_BUILD_STORAGE_KEY, APP_BUILD_ID);

    if (hasPreviousBuild && isUpdatedBuild) {
      showUpdateModal(() => {
        const refreshUrl = new URL(window.location.href);
        refreshUrl.searchParams.set("_v", Date.now().toString());
        window.location.replace(refreshUrl.toString());
      });
      return true;
    }
  } catch (error) {
    // If storage is blocked, continue normally without update prompt.
  }

  return false;
}
